
    import { Vue, Component, Prop } from "vue-property-decorator";
  
    @Component
    export default class NewTabLinkFull extends Vue {
      @Prop({ type: String, default: undefined }) readonly url?: string;
    }
  